import "./bootstrap";
import initHeader from "./components/initHeader.js";
// import cookiesInit from "./components/cookies";

document.addEventListener("DOMContentLoaded", () => {

    initHeader();

});
